import React from "react";
import ReactPaginate from "react-js-pagination";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faAngleLeft, faAngleRight, faAnglesLeft, faAnglesRight,
} from "@fortawesome/free-solid-svg-icons";
import {Col, Row} from "react-bootstrap";

const Pagination = ({
                      propCurPage = 1,
                      propTotal = 0,
                      propPageSize = 15,
                      propSetNewPage = null,
                      propSetIsSearch,
                    }) => {

  const handlePageChange = (page) => {
      if (propSetIsSearch) {
        propSetIsSearch(true);

      }
    propSetNewPage(page);
  };

  return (
      <Row>
        <Col md={4} className={""}>
          <div className={"page-info d-inline h-100 align-middle ms-2"}>
            Showing <span>{propPageSize * (propCurPage - 1) + 1}</span> to <span>{propTotal < propCurPage * propPageSize ? propTotal : propCurPage * propPageSize}</span> of <span>{propTotal}</span> entries
          </div>
        </Col>

        <Col md={8}>
          <ReactPaginate
              activePage={propCurPage}
              itemsCountPerPage={propPageSize}
              totalItemsCount={propTotal}
              pageRangeDisplayed={5}
              prevPageText={
                <div className={"previous fs-6 ms-1"}>
                  <FontAwesomeIcon icon={faAngleLeft} className={"pe-2"}/>
                </div>
              }
              firstPageText={
                <div className={"previous fs-6 ms-1"}>
                  <FontAwesomeIcon icon={faAnglesLeft} className={"pe-2"}/>
                </div>
              }
              nextPageText={
                <div className={"next fs-6 me-1"}>
                  <FontAwesomeIcon icon={faAngleRight} className={"ps-2"}/>
                </div>
              }
              lastPageText={
                <div className={"previous fs-6 ms-1"}>
                  <FontAwesomeIcon icon={faAnglesRight} className={"pe-2"}/>
                </div>
              }
              onChange={handlePageChange}
              activeClass={"active"}
              innerClass={"pagination justify-content-end"}
              itemClass={"page-item"}
              linkClass={"page-link"}
              itemClassPrev={"prev"}
              itemClassNext={"next"}
              itemClassFirst={"first"}
              itemClassLast={"last"}
          />
        </Col>
      </Row>
  );
};

export default Pagination;
